import { defineComponent as _defineComponent } from 'vue'
import {
  FlipEvent,
  NFTExcludingEvents,
} from '@/composables/collectionActivity/types'
import Flipper from './NFTSDetailsDropdown/Flipper.vue'
import Holder from './NFTSDetailsDropdown/Holder.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NFTsDetaislDropdown',
  props: {
    variant: null,
    holderNfts: { default: () => [] },
    flips: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true,Flipper, Holder }
}

})